import { Action, createReducer, on } from "@ngrx/store";

import { Basket } from "@hermes/api-model-basket";

import * as BasketActions from "../actions/basket.actions";
import { EcomError } from "../models/basket-feature.model";

export const basketFeatureKey = "basket";

export interface State {
    cart: Basket;
    error: {
        hasError: boolean;
        ecomError: EcomError;
    };
    // request status
    pending: boolean;
    isInitialized: boolean;
}

export const initialState: State = {
    cart: new Basket({ items: [] }),
    error: {
        hasError: false,
        ecomError: undefined as unknown as EcomError,
    },
    pending: false,
    isInitialized: false,
};

const basketReducer = createReducer(
    initialState,
    on(
        BasketActions.addToCart,
        BasketActions.addManyToCart,
        BasketActions.resetCart,
        BasketActions.removeFromCart,
        BasketActions.setCartItem,
        (state, _action) => ({
            ...state,
            error: {
                hasError: false,
                ecomError: undefined as unknown as EcomError,
            },
            pending: true,
        }),
    ),
    on(
        BasketActions.addToCartSuccess,
        BasketActions.addManyToCartSuccess,
        BasketActions.resetCartSuccess,
        BasketActions.setBasket,
        BasketActions.removeFromCartSuccess,
        BasketActions.setCartItemSuccess,
        BasketActions.persistBasketSuccess,
        (state, action) => ({
            cart: action.basket,
            error: {
                hasError: false,
                ecomError: undefined as unknown as EcomError,
            },
            pending: false,
            isInitialized: true,
        }),
    ),
    on(
        BasketActions.addToCartFailure,
        BasketActions.addManyToCartFailure,
        BasketActions.resetCartFailure,
        BasketActions.removeFromCartFailure,
        BasketActions.setCartItemFailure,
        BasketActions.persistBasketFailure,
        (state, action) => ({
            ...state,
            error: {
                hasError: true,
                ecomError: action.error,
            },
            pending: false,
        }),
    ),
    on(BasketActions.clearData, (_state, _action) => initialState),
);

export function reducer(state: State | undefined, action: Action): State {
    return basketReducer(state, action);
}
